module.exports = __webpack_public_path__ + "img/secure-cloud.06cc3d8b.svg";